import { ReactNode, useEffect, useRef, useState } from 'react'
import { IconButton } from '@cargomart/ui'
import IconClear from 'assets/clear.svg?react'
import IconSearch from 'assets/search.svg?react'
import cn from 'classnames'

type Props = {
  handleSearch: (search: string) => void
  placeholder: string
  searchQuery: string
  className?: string
  iconPoint?: ReactNode
  isInDetailPage?: boolean
  isOrder?: boolean
  isShowSelect?: boolean
  postfix?: React.ReactNode
}

const Search = ({
  isInDetailPage,
  searchQuery,
  placeholder,
  handleSearch,
  postfix,
  isOrder,
  iconPoint,
  className,
  isShowSelect
}: Props) => {
  const [isFocused, setIsFocused] = useState(false)
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  const handleClear = () => {
    handleSearch('')
  }

  useEffect(() => {
    if (isShowSelect) {
      handleFocus()
    }
  }, [isShowSelect])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.blur()
    }
  }, [])

  return (
    <div
      className={cn(
        'duration relative flex w-6/12 cursor-text flex-nowrap items-center justify-between rounded border border-solid border-[color:var(--cm-theme-outline,#c7c6ca)] bg-on-primary px-2 py-0 transition-shadow ease-[ease-in-out]',
        'max-md:w-full',
        'max-[599px]:order-1 max-[599px]:mb-2.5',
        {
          'z-[3] shadow-[inset_0_0_0_1px_#0087ff,0_0_0_2px_#0087ff66] hover:shadow-[inset_0_0_0_1px_#0087ff,0_0_0_2px_#0087ff66]':
            isFocused,
          'hover:z-[2] hover:[box-shadow:inset_0_0_0_1px_#0000003d]': !isFocused,
          'h-8 w-full': isInDetailPage
        },
        className
      )}
    >
      {isOrder ? iconPoint : <IconSearch className="mr-1 text-[#1a1c1e]" size="xs" />}
      <input
        ref={inputRef}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={isInDetailPage}
        onBlur={handleBlur}
        onChange={(e) => handleSearch(e.target.value)}
        onFocus={handleFocus}
        placeholder={placeholder}
        type="text"
        value={searchQuery}
        className={cn(
          '!shadow-none m-0 box-content h-8 w-full resize-none py-0.5 text-body-md text-[rgba(0,0,0,0.72)] ![border:none] ![outline:none] [background:0_center]',
          'placeholder:select-none placeholder:text-[#6e7076]',
          {
            'ml-6': isOrder
          }
        )}
      />
      <div className="flex items-center gap-1">
        {searchQuery.length > 0 && (
          <IconButton onClick={handleClear} size="sm">
            <IconClear />
          </IconButton>
        )}
        {postfix}
      </div>
    </div>
  )
}

export default Search
